document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header')
  if (!header) return;

  const apply = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 0);
  };

  apply();

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      apply();
      ticking = false;
    });
  }, { passive: true });
});
